/* FSN multi-pack selector (V7 evergreen / V8 BFCM).
   Mounts into the existing product form on standard quote napkin PDPs, configured by sections/fsn-multipack.liquid.
   Display only: prices shown here come from the section settings; checkout pricing comes from Shopify discounts.
   If anything fails before the end, <html> never gets .fsn-mp-ready and the theme's own form stays as it was. */
(() => {
  const cfgEl = document.getElementById('fsn-mp-config');
  const form = document.querySelector('.sp-product-form-container form.fs-product-form') || document.querySelector('form.fs-product-form');
  if (!cfgEl || !form) return;
  let C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!Array.isArray(C.prices) || C.prices.length !== 5 || C.prices.some(p => !(p > 0)) || (C.currency !== C.shopCurrency && (!(C.baseUsd > 0) || !(C.basePrice > 0)))) {
    console.warn('[fsn-multipack] invalid price settings, leaving the original form in place');
    return;
  }

  // ---------- money ----------
  // Settings are USD. Other markets scale by this product's own price ratio (same as the prototype),
  // so market price rounding is respected. On the US store this is exactly 1.
  // US store (shop currency) is always exact, even mid price-change; other markets scale by this product's own price
  const rate = C.currency === C.shopCurrency ? 1 : C.basePrice / C.baseUsd;
  const cur = C.currency || 'USD';
  const conv = usd => Math.round(usd * rate);
  const fmt = cents => {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  // ---------- offer ----------
  const BF = C.mode === 'bfcm';
  const P = C.prices;                       // USD cents, totals for 1..5 packs
  const REF = P[0];                         // single-pack price that strike-throughs and savings are measured against
  const FREE_AT = [3, 5];                   // BFCM: these pack positions are free
  const TIERS = BF
    ? [
        { count: 5, total: C.bfcm.buy3get2, badge: 'BEST VALUE', label: 'Buy 3, Get 2 Free', sub: '5 packs' },
        { count: 3, total: C.bfcm.buy2get1, badge: 'MOST POPULAR', label: 'Buy 2, Get 1 Free', sub: '3 packs', def: true },
        { count: 1, total: P[0], badge: '' },
      ]
    : [5, 4, 3, 2, 1].map(n => ({ count: n, total: P[n - 1], badge: n === 3 ? 'MOST POPULAR' : n === 5 ? 'BEST VALUE' : '', def: n === C.defaultPack }));
  const canGrow = !BF;                      // evergreen: the 5 pack can grow, every extra pack at the 5-pack rate
  const CAP = Math.max(5, C.bulkCap || 20);
  const shipList = (C.shipCountries || []).filter(Boolean);
  const shipOK = !shipList.length || shipList.includes(C.country);

  // ---------- catalogue ----------
  const SEASONAL = /christmas|holiday|halloween|thanksgiving/i;
  const terms = (C.excludeTerms || []).map(t => t.trim()).filter(Boolean);
  const excluded = title => terms.some(t => title.toLowerCase().includes(t));
  const byHandle = {};
  const add = p => { if (p && p.handle && !byHandle[p.handle]) byHandle[p.handle] = p; };
  const current = C.current; add(current);
  const BEST = (C.best || []).filter(b => b.price === current.price && !excluded(b.title)); // never offer a different format
  BEST.forEach(add);
  // seasonal designs, soonest holiday first (Halloween, Thanksgiving, Christmas, Easter...)
  const HOLIDAY_MONTH = [[/halloween/i, 10], [/thanksgiving|thankful/i, 11], [/christmas|holiday|merry|snow|season|ho ho|naughty|santa/i, 12], [/valentine/i, 2], [/easter/i, 4], [/patrick/i, 3]];
  const monthsAway = p => { const m = (HOLIDAY_MONTH.find(([re]) => re.test(p.title)) || [0, 13])[1]; return m > 12 ? 99 : (m - (new Date().getMonth() + 1) + 12) % 12; };
  const SEASON = (C.seasonal || []).filter(p => p.price === current.price && !BEST.some(b => b.handle === p.handle))
    .sort((a, b) => monthsAway(a) - monthsAway(b));
  SEASON.forEach(add);
  const isSeasonal = p => SEASONAL.test(p.title) || (p.tags || []).some(t => SEASONAL.test(t));
  const rankOf = h => (BEST.find(b => b.handle === h) || {}).rank;
  const firstAvail = p => p.variants.find(v => v.available) || p.variants[0];
  // a colour carries over to another design only if that design has it in stock
  const variantOf = (p, title) => p.variants.find(v => v.title === title && v.available) || firstAvail(p);
  const shortName = p => p.title.replace(/ Quotes? Napkins/i, '').replace(/ - (White|Red) with (Red|White) Quotes/i, ' ($1)').replace(/ Cocktail Napkins/i, '').replace(' | ', ' · ');
  const img = (src, w) => {
    const u = (src || '').replace(/^\/\//, 'https://').replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '';
  };
  const SWATCH = { white: '#fff', black: '#141414', red: '#b3262e', gold: '#c9a74b', silver: '#c0c0c0', orange: '#e07a1f' };
  let QUOTES = null;
  const getCol = h => h ? fetch(`/collections/${h}/products.json?limit=250`).then(r => r.json()).then(d => d.products || []).catch(() => []) : Promise.resolve([]);
  const loadQuotes = () => QUOTES ? Promise.resolve(QUOTES) : Promise.all([getCol(C.collection), getCol(C.seasonalCollection)])
    .then(([a, b]) => {
      const seen = new Set();
      QUOTES = [...a, ...b].filter(p => !seen.has(p.handle) && seen.add(p.handle))
        .filter(p => !excluded(p.title) && Math.round(parseFloat(p.variants[0].price) * 100) === current.price)
        .map(p => ({
          handle: p.handle, title: p.title, tags: p.tags,
          variants: p.variants.map(v => ({ id: v.id, title: v.title, available: v.available, img: ((p.images.find(i => i.variant_ids.includes(v.id)) || p.images[0] || {}).src) || '' })),
        }));
      QUOTES.forEach(add);
      return QUOTES;
    }).catch(() => { QUOTES = null; return []; });

  // ---------- state ----------
  let sel = Math.max(0, TIERS.findIndex(t => t.def));
  let extra = 0, openDd = -1, err = '', busy = false;
  let rows = [];
  const initialColour = (form.querySelector('option-compenent .zop-title span') || {}).textContent?.trim();
  const tierCount = i => TIERS[i].count + (canGrow && i === 0 ? extra : 0);
  function fitRows() {
    const need = tierCount(sel);
    while (rows.length < need) rows.push({ handle: current.handle, colour: variantOf(current, rows[0] ? rows[0].colour : initialColour).title });
    rows = rows.slice(0, need);
  }
  fitRows();
  const rowVariant = r => variantOf(byHandle[r.handle] || current, r.colour);
  const soldOutRows = () => rows.map((r, j) => (rowVariant(r).available ? -1 : j)).filter(j => j > -1);

  // ---------- mount: hide the theme's colour, pack, quantity and button blocks; keep everything else ----------
  ['option-compenent', '.quoteview-wrap', '.jsp-groups', '.z-savetext', '.qty-ad-wrap', '.sbp-qty', '.product-form__buttons']
    .forEach(q => form.querySelectorAll(q).forEach(el => el.classList.add('fsn-mp-hidden')));
  document.querySelectorAll('.product-form-sticky-button').forEach(el => el.classList.add('fsn-mp-hidden'));
  // every add goes through addToBag(); the hidden single-variant fields must never submit (e.g. Enter in the search box)
  form.addEventListener('submit', e => { e.preventDefault(); e.stopImmediatePropagation(); }, true);
  const shipsEl = form.querySelector('.pdp-ships-estimate');
  const shipsHTML = shipsEl ? `<p class="pdp-ships-estimate fsn-mp__ships" style="${(shipsEl.getAttribute('style') || '').replace(/"/g, '')}">${shipsEl.textContent.trim().replace(/</g, '&lt;')}</p>` : '';
  const saveTpl = (form.querySelector('.z-savetext[data-save-template]') || {}).dataset?.saveTemplate || 'Congrats! You are saving //save//%';
  const root = document.createElement('div');
  root.className = 'fsn-mp';
  form.appendChild(root);
  // our own sticky bar (the theme's one submits the original single-variant form, so it stays hidden)
  const sticky = document.createElement('div');
  sticky.className = 'fsn-mp-sticky';
  sticky.innerHTML = '<button type="button" class="fsn-mp-sticky__btn"></button>';
  document.body.appendChild(sticky);
  const stickyBtn = sticky.firstElementChild;
  if (C.previewNotice) {
    document.documentElement.classList.add('fsn-mp-preview');
    document.documentElement.style.setProperty('--fsn-mp-preview-text', JSON.stringify(C.previewNoticeText || 'Preview pricing'));
  }

  const ICON_ZOOM = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6"/><path d="M15 15l5 5"/></svg>';
  const ICON_EYE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>';
  const ICON_TICK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  // ---------- pricing ----------
  function priceFor(i) {
    const n = tierCount(i);
    const usd = n > 5 ? Math.round((P[4] / 5) * n) : TIERS[i].total;
    const full = conv(REF) * n;
    let total = conv(usd);
    if (rate !== 1) {
      // other markets have their own price lists: apply the same % off to the local price, like checkout does.
      // Snap to a clean % (15.00 not 14.99) so a ladder built from today's discounts lands on the exact local cent.
      let pct = 1 - usd / (REF * n);
      const snap = Math.round(pct * 200) / 200;
      if (Math.abs(pct - snap) < 0.0005) pct = snap;
      total = Math.round(full * (1 - pct));
    }
    return { n, total, full, save: full - total, each: total / n };
  }

  // ---------- render ----------
  function render() {
    const oos = soldOutRows().length > 0;
    root.innerHTML = `
      <div class="zop-title fsn-mp__title">PACK SIZE:<span> 50x Napkins per pack</span></div>
      <div class="fsn-mp__tiers" role="radiogroup" aria-label="Choose a pack size">${TIERS.map((t, i) => card(i)).join('')}</div>
      <div class="fsn-mp__atc-wrap">
        <button type="button" class="addtocart fsn-mp__atc ${busy ? 'is-busy' : ''}" ${oos || busy ? 'disabled' : ''}>${atcLabel()}</button>
        ${err ? `<p class="fsn-mp__err" role="alert">${esc(err)}</p>` : ''}
        ${shipsHTML}
      </div>`;
    stickyBtn.innerHTML = atcLabel(true);
    stickyBtn.disabled = busy;
  }

  function card(i) {
    const t = TIERS[i], on = i === sel, pr = priceFor(i);
    const perks = [pr.n >= C.perksFrom && shipOK && C.shipLabel, pr.n >= (C.giftFrom || C.perksFrom) && C.giftLabel].filter(Boolean);
    const name = t.label ? `${t.label}<small class="fsn-mp__deal">${t.sub}</small>` : `${pr.n} Pack`;
    return `<div class="fsn-mp__card ${on ? 'is-on' : ''}" data-tier="${i}" role="radio" aria-checked="${on}" tabindex="0">
      ${t.badge ? `<span class="fsn-mp__badge">${t.badge}</span>` : ''}
      <div class="fsn-mp__head">
        <span class="fsn-mp__radio" aria-hidden="true"></span>
        <span class="fsn-mp__name">${name}</span>
        <span class="fsn-mp__price">
          <span class="fsn-mp__total">${fmt(pr.total)}${pr.save > 0 ? ` <s>${fmt(pr.full)}</s>` : ''}</span>
          ${pr.save > 0 ? `<span class="fsn-mp__each">${fmt(Math.round(pr.each))} per pack</span>` : ''}
        </span>
      </div>
      ${on ? `<div class="fsn-mp__body">
        ${pr.save > 0 ? `<div class="fsn-mp__savings"><span>Your savings</span><span class="fsn-mp__pill">SAVE ${fmt(pr.save)}</span></div>` : ''}
        ${rowsHTML()}
      </div>` : ''}
      ${perks.length ? `<div class="fsn-mp__perks">${perks.map(p => `<div class="fsn-mp__perk">${ICON_TICK}<span>${esc(p)}</span></div>`).join('')}</div>` : ''}
    </div>`;
  }

  function rowsHTML() {
    const pool = [...((C.hideSeasonal && isSeasonal(current)) ? [] : [current.handle]), ...BEST.map(b => b.handle).filter(h => h !== current.handle)];
    const seasonPool = (C.hideSeasonal ? [] : SEASON.map(p => p.handle)).filter(h => !pool.includes(h));
    return `<div class="fsn-mp__sub">Choose a style + colour for each pack</div>
      <div class="fsn-mp__rows">${rows.map((r, j) => {
        const p = byHandle[r.handle] || current, v = rowVariant(r), cols = p.variants;
        const isFree = BF && FREE_AT.includes(j + 1);
        const list = pool.includes(r.handle) || seasonPool.includes(r.handle) ? pool : [r.handle, ...pool];
        return `<div class="fsn-mp__row ${isFree ? 'is-free' : ''} ${cols.length > 2 ? 'is-many' : ''} ${v.available ? '' : 'is-oos'}">
          ${isFree ? '<em class="fsn-mp__free">FREE</em>' : ''}
          <span class="fsn-mp__num">${j + 1}</span>
          <button type="button" class="fsn-mp__thumb-btn" data-qv="${j}" aria-label="Preview ${esc(shortName(p))}: photos and quotes"><img class="fsn-mp__thumb" src="${img(v.img, 120)}" alt="" width="36" height="36" loading="lazy"><i class="fsn-mp__zoom" aria-hidden="true">${ICON_ZOOM}</i></button>
          <div class="fsn-mp__dd ${openDd === j ? 'is-open' : ''}">
            <button type="button" class="fsn-mp__dd-btn" data-dd="${j}" aria-haspopup="listbox" aria-expanded="${openDd === j}" aria-label="Pack ${j + 1}: ${esc(shortName(p))}, ${esc(v.title)}">
              <span>${esc(shortName(p))}${!v.available ? ' <small>· Sold out</small>' : v.title === 'Default Title' ? '' : ` <small>· ${esc(v.title)}</small>`}</span><i aria-hidden="true"></i></button>
            ${openDd === j ? `<ul class="fsn-mp__dd-list" role="listbox">
              ${list.map(h => opt(j, h, r.handle)).join('')}
              ${seasonPool.length ? `<li class="fsn-mp__dd-group" role="presentation">Seasonal</li>${seasonPool.map(h => opt(j, h, r.handle)).join('')}` : ''}
              <li class="fsn-mp__dd-search" role="presentation">
                <input type="search" data-search="${j}" placeholder="Search all quote napkins…" aria-label="Search all quote napkins" autocomplete="off" enterkeyhint="search">
                <ul class="fsn-mp__dd-results" data-results="${j}"></ul>
              </li>
            </ul>` : ''}
          </div>
          ${cols.length > 1 ? `<span class="fsn-mp__dots">${cols.map(x => {
            const hex = SWATCH[x.title.toLowerCase()];
            const bg = hex ? `background:${hex}` : `background:#eee url('${img(x.img, 60)}') center/cover`;
            return `<button type="button" class="fsn-mp__dot ${x.title === v.title ? 'is-on' : ''}" data-row="${j}" data-colour="${esc(x.title)}" ${x.available ? '' : 'disabled'} title="${esc(x.title)}${x.available ? '' : ' (sold out)'}" aria-label="Pack ${j + 1} ${esc(x.title)}${x.available ? '' : ', sold out'}" aria-pressed="${x.title === v.title}" style="${bg}"></button>`;
          }).join('')}</span>` : ''}
          ${canGrow && extra && j >= rows.length - extra ? `<button type="button" class="fsn-mp__rm" data-rm="${j}" aria-label="Remove pack ${j + 1}">×</button>` : ''}
        </div>`;
      }).join('')}</div>
      ${canGrow && sel === 0 && rows.length < CAP ? `<button type="button" class="fsn-mp__addpack" data-addpack>
        <span class="fsn-mp__plus" aria-hidden="true">+</span><span>Add another pack <small>${fmt(Math.round(conv(P[4]) / 5))} each, same ${Math.round((1 - P[4] / 5 / REF) * 100)}% off</small></span></button>` : ''}
      <p class="fsn-mp__per-pack">50 napkins per pack</p>`;
  }

  function opt(j, h, chosen) {
    const p = byHandle[h] || current, v = firstAvail(p), oos = !p.variants.some(x => x.available);
    return `<li role="option" aria-selected="${h === chosen}"><button type="button" class="fsn-mp__opt ${h === chosen ? 'is-on' : ''}" data-pick="${j}" data-h="${esc(h)}" ${oos ? 'disabled' : ''}>
      <img src="${img(v.img, 80)}" alt="" width="36" height="36" loading="lazy">
      <span><b>${esc(shortName(p))}</b><small>${oos ? 'Sold out' : h === current.handle ? 'This design' : rankOf(h) ? `#${rankOf(h)} bestseller` : isSeasonal(p) ? 'Seasonal' : 'Quote napkins'}</small></span></button>
      <button type="button" class="fsn-mp__opt-qv" data-qvh="${esc(h)}" data-qv-row="${j}" aria-label="Preview ${esc(shortName(p))}" title="Preview">${ICON_EYE}</button></li>`;
  }

  function congrats() {
    const pr = priceFor(sel), pct = Math.round((pr.save / pr.full) * 100);
    return pct > 0 ? `<div class="z-savetext fsn-mp__congrats">${esc(saveTpl.replace('//save//', pct))}</div>` : '';
  }
  function atcLabel(compact) {
    if (busy) return '<span>Adding…</span>';
    const oos = soldOutRows();
    if (oos.length) return `<span>Pack ${oos.map(j => j + 1).join(', ')} sold out: pick another</span>`;
    const pr = priceFor(sel);
    return `<span><span class="atb">Add To Bag</span> <span class="pr">| ${fmt(pr.total)}${!compact && pr.save > 0 ? ` <s>${fmt(pr.full)}</s>` : ''}</span></span>`;
  }

  // ---------- events ----------
  root.addEventListener('click', e => {
    const q = s => e.target.closest(s);
    if (q('.fsn-mp__atc')) return addToBag();
    if (q('[data-addpack]')) { extra = Math.min(extra + 1, CAP - 5); fitRows(); return render(); }
    const rm = q('[data-rm]'); if (rm) { rows.splice(+rm.dataset.rm, 1); extra = Math.max(0, extra - 1); fitRows(); return render(); }
    const dd = q('[data-dd]');
    if (dd) {
      openDd = openDd === +dd.dataset.dd ? -1 : +dd.dataset.dd; render();
      if (openDd > -1) { loadQuotes(); root.querySelector('.fsn-mp__opt.is-on')?.scrollIntoView({ block: 'nearest' }); }
      return;
    }
    const qvRow = q('[data-qv]');
    if (qvRow) { const j = +qvRow.dataset.qv; openDd = -1; render(); return openQV(j, rows[j].handle, rowVariant(rows[j]).title, root.querySelector(`[data-qv="${j}"]`)); }
    const qvOpt = q('[data-qvh]');
    if (qvOpt) { const j = +qvOpt.dataset.qvRow; openDd = -1; render(); return openQV(j, qvOpt.dataset.qvh, rows[j].colour, root.querySelector(`[data-dd="${j}"]`)); }
    const pk = q('[data-pick]');
    if (pk) {
      if (pk.disabled) return;
      const j = +pk.dataset.pick, p = byHandle[pk.dataset.h] || current;
      rows[j] = { handle: p.handle, colour: variantOf(p, rows[j].colour).title };
      openDd = -1; err = ''; render(); root.querySelector(`[data-dd="${j}"]`)?.focus(); return;
    }
    const dot = q('[data-colour]');
    if (dot) {
      if (dot.disabled) return;
      const j = +dot.dataset.row; rows[j].colour = dot.dataset.colour; err = '';
      if (j === 0 && rows[0].handle === current.handle) syncGallery(dot.dataset.colour);
      return render();
    }
    if (q('.fsn-mp__body')) return;
    const c = q('[data-tier]');
    if (c) { const i = +c.dataset.tier; if (i !== sel) { sel = i; extra = 0; openDd = -1; err = ''; fitRows(); render(); } }
  });
  root.addEventListener('keydown', e => {
    const c = e.target.closest('[data-tier]');
    if (c && e.target === c && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); c.click(); return; }
    const s = e.target.closest('[data-search]');
    if (s && e.key === 'Enter') { e.preventDefault(); root.querySelector(`[data-results="${s.dataset.search}"] .fsn-mp__opt:not([disabled])`)?.click(); }
  });
  root.addEventListener('input', e => {
    const s = e.target.closest('[data-search]'); if (!s) return;
    const j = +s.dataset.search, out = root.querySelector(`[data-results="${j}"]`), term = s.value.trim().toLowerCase();
    if (!term) { out.innerHTML = ''; return; }
    loadQuotes().then(list => {
      if (!s.isConnected || s.value.trim().toLowerCase() !== term) return; // a newer keystroke owns the results
      const hits = list.filter(p => !(C.hideSeasonal && isSeasonal(p)) && p.title.toLowerCase().includes(term)).slice(0, 8);
      out.innerHTML = hits.length ? hits.map(p => opt(j, p.handle, rows[j].handle)).join('') : `<li class="fsn-mp__none">No quote napkins match "${esc(s.value.trim())}"</li>`;
    });
  });
  document.addEventListener('click', e => { if (openDd > -1 && !e.target.closest('.fsn-mp__dd')) { openDd = -1; render(); } });
  document.addEventListener('keydown', e => {
    if (openDd < 0) return;
    if (e.key === 'Escape') { const j = openDd; openDd = -1; render(); root.querySelector(`[data-dd="${j}"]`)?.focus(); return; }
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      const opts = [...root.querySelectorAll('.fsn-mp__opt:not([disabled])')], i = opts.indexOf(document.activeElement);
      opts[Math.max(0, Math.min(opts.length - 1, i + (e.key === 'ArrowDown' ? 1 : -1)))]?.focus();
    }
  });

  // sticky bar: shows while the whole selector is off screen. Below it (not seen yet) it scrolls up to the packs;
  // above it (already chosen) it adds the same bundle.
  // measured directly on scroll/resize (one read per frame) so fast flings and jumps can never leave it stale
  let stickyFrame = 0;
  const placeSticky = () => {
    stickyFrame = 0;
    const b = root.getBoundingClientRect();
    sticky.classList.toggle('is-on', b.bottom < 0 || b.top > window.innerHeight);
  };
  const queueSticky = () => { if (!stickyFrame) stickyFrame = requestAnimationFrame(placeSticky); };
  window.addEventListener('scroll', queueSticky, { passive: true });
  window.addEventListener('resize', queueSticky, { passive: true });
  stickyBtn.addEventListener('click', () => {
    if (root.getBoundingClientRect().top > 0 || soldOutRows().length) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else addToBag();
  });

  // pack 1 colour follows the theme gallery via its own (hidden) swatch
  function syncGallery(colour) {
    const a = form.querySelector(`option-compenent a[title="${colour.replace(/"/g, '')}"]`);
    if (a) a.click();
  }

  // ---------- quick view: a slide-out drawer to compare a design before choosing it ----------
  // photos + colours come from /products/<handle>.js; the quote list from this template's own quotes section
  // (rendered for the other product via ?section_id=), so it always matches what that product page shows.
  const quotesSectionId = (document.querySelector('.fsp-quo')?.closest('.shopify-section')?.id || '').replace('shopify-section-', '');
  const qvCache = {};
  const fetchQV = h => qvCache[h] || (qvCache[h] = Promise.all([
    fetch(`/products/${h}.js`).then(r => r.json()),
    quotesSectionId ? fetch(`/products/${h}?section_id=${quotesSectionId}`).then(r => (r.ok ? r.text() : '')).catch(() => '') : Promise.resolve(''),
  ]).then(([prod, html]) => {
    const doc = html ? new DOMParser().parseFromString(html, 'text/html') : null;
    const quotes = doc ? [...doc.querySelectorAll('.fsp-quo li')].map(li => ({ q: (li.querySelector('strong') || li).textContent.trim(), by: (li.querySelector('em') || {}).textContent?.trim() || '' })).filter(x => x.q) : [];
    return { prod, quotes };
  }).catch(e => { delete qvCache[h]; throw e; }));

  const qvEl = document.createElement('div');
  qvEl.className = 'fsn-qv';
  qvEl.hidden = true;
  qvEl.innerHTML = `<div class="fsn-qv__scrim" data-qv-close></div>
    <aside class="fsn-qv__panel" role="dialog" aria-modal="true" aria-labelledby="fsn-qv-title">
      <button type="button" class="fsn-qv__close" data-qv-close aria-label="Close preview">&times;</button>
      <div class="fsn-qv__body"></div>
      <div class="fsn-qv__foot"><button type="button" class="fsn-qv__use"></button><a class="fsn-qv__more" href="#">View full details</a></div>
    </aside>`;
  document.body.appendChild(qvEl);
  const qvBody = qvEl.querySelector('.fsn-qv__body'), qvUse = qvEl.querySelector('.fsn-qv__use'), qvMore = qvEl.querySelector('.fsn-qv__more');
  let qv = null, qvReturn = null, qvAll = false;

  function openQV(row, handle, colour, returnTo) {
    qv = { row, handle, colour, data: null }; qvReturn = returnTo || null; qvAll = false;
    qvBody.innerHTML = '<p class="fsn-qv__loading">Loading…</p>';
    qvUse.disabled = true; qvUse.textContent = `Use for Pack ${row + 1}`;
    qvMore.href = `/products/${handle}`;
    qvEl.hidden = false;
    document.documentElement.classList.add('fsn-qv-open');
    requestAnimationFrame(() => requestAnimationFrame(() => qvEl.classList.add('is-open')));
    qvEl.querySelector('.fsn-qv__close').focus();
    fetchQV(handle).then(d => { if (qv && qv.handle === handle) { qv.data = d; drawQV(); } })
      .catch(() => { if (qv && qv.handle === handle) qvBody.innerHTML = '<p class="fsn-qv__loading">Sorry, this preview didn\'t load. Try again, or open the full details below.</p>'; });
  }
  function closeQV() {
    if (!qv) return;
    qv = null;
    qvEl.classList.remove('is-open');
    document.documentElement.classList.remove('fsn-qv-open');
    setTimeout(() => { if (!qv) qvEl.hidden = true; }, 300);
    qvReturn?.focus?.();
  }
  function drawQV(keepScroll) {
    const { prod } = qv.data, quotes = qv.data.quotes;
    const vars = prod.variants.filter(v => v.title !== 'Default Title');
    const pick = prod.variants.find(v => v.title === qv.colour && v.available) || prod.variants.find(v => v.available) || prod.variants[0];
    qv.colour = pick.title;
    const hero = (pick.featured_image && pick.featured_image.src) || prod.featured_image;
    const pics = [hero, ...prod.images].filter((s, i, a) => s && a.findIndex(x => img(x, 1) === img(s, 1)) === i).slice(0, 10);
    const shown = qvAll ? quotes : quotes.slice(0, 5);
    const scroll = keepScroll ? qvBody.scrollTop : 0;
    qvBody.innerHTML = `
      <div class="fsn-qv__gallery" aria-label="Photos">
        <div class="fsn-qv__track">${pics.map((s, i) => `<img src="${img(s, 900)}" alt="${esc(prod.title)}${i ? ` photo ${i + 1}` : ''}" width="900" height="900" ${i ? 'loading="lazy"' : ''}>`).join('')}</div>
        ${pics.length > 1 ? `<button type="button" class="fsn-qv__nav is-prev" data-qv-nav="-1" aria-label="Previous photo">&#8249;</button><button type="button" class="fsn-qv__nav is-next" data-qv-nav="1" aria-label="Next photo">&#8250;</button><span class="fsn-qv__count">1 / ${pics.length}</span>` : ''}
      </div>
      <div class="fsn-qv__info">
        <h2 id="fsn-qv-title" class="fsn-qv__title">${esc(prod.title)}</h2>
        <p class="fsn-qv__price">${fmt(prod.price)} a pack <span>· 50 napkins · 4.5″ × 4.5″</span></p>
        ${vars.length > 1 ? `<div class="fsn-qv__label">Colour: <b>${esc(pick.title)}</b></div>
        <div class="fsn-qv__colours">${vars.map(v => {
          const hex = SWATCH[v.title.toLowerCase()];
          const bg = hex ? `background:${hex}` : `background:#eee url('${img((v.featured_image || {}).src || prod.featured_image, 80)}') center/cover`;
          return `<button type="button" class="fsn-mp__dot ${v.title === pick.title ? 'is-on' : ''}" data-qv-colour="${esc(v.title)}" ${v.available ? '' : 'disabled'} title="${esc(v.title)}${v.available ? '' : ' (sold out)'}" aria-label="${esc(v.title)}${v.available ? '' : ', sold out'}" aria-pressed="${v.title === pick.title}" style="${bg}"></button>`;
        }).join('')}</div>` : ''}
        ${quotes.length ? `<ul class="fsn-qv__quotes">${shown.map(x => `<li><span>${esc(x.q)}</span>${x.by ? `<em>${esc(x.by)}</em>` : ''}</li>`).join('')}</ul>
        ${quotes.length > 5 ? `<button type="button" class="fsn-qv__all" data-qv-all>${qvAll ? 'Show fewer quotes' : 'Show all quotes'}</button>` : ''}` : ''}
        <ul class="fsn-qv__specs">
          <li>50 napkins per pack</li>
          <li>100% organic cotton, 4.5″ × 4.5″ cocktail size</li>
          <li>Gift-boxed and ready for the party</li>
        </ul>
      </div>`;
    qvBody.scrollTop = scroll;
    const sameAsRow = rows[qv.row] && rows[qv.row].handle === qv.handle && rowVariant(rows[qv.row]).title === qv.colour;
    qvUse.disabled = !pick.available;
    qvUse.textContent = !pick.available ? 'Sold out' : sameAsRow ? `Keep for Pack ${qv.row + 1}` : `Use for Pack ${qv.row + 1}`;
    const track = qvBody.querySelector('.fsn-qv__track'), count = qvBody.querySelector('.fsn-qv__count');
    if (track && count) track.addEventListener('scroll', () => { count.textContent = `${Math.round(track.scrollLeft / track.clientWidth) + 1} / ${pics.length}`; }, { passive: true });
  }

  qvEl.addEventListener('click', e => {
    const q = s => e.target.closest(s);
    if (q('[data-qv-close]')) return closeQV();
    const nav = q('[data-qv-nav]');
    if (nav) { const tr = qvBody.querySelector('.fsn-qv__track'); return tr.scrollBy({ left: tr.clientWidth * +nav.dataset.qvNav, behavior: 'smooth' }); }
    if (q('[data-qv-all]')) { qvAll = !qvAll; return drawQV(true); }
    const col = q('[data-qv-colour]');
    if (col && !col.disabled) { qv.colour = col.dataset.qvColour; return drawQV(true); }
    if (q('.fsn-qv__use') && qv && qv.data) {
      const j = qv.row, h = qv.handle;
      if (!byHandle[h]) add({ handle: h, title: qv.data.prod.title, tags: qv.data.prod.tags, variants: qv.data.prod.variants.map(v => ({ id: v.id, title: v.title, available: v.available, img: (v.featured_image && v.featured_image.src) || qv.data.prod.featured_image })) });
      rows[j] = { handle: h, colour: qv.colour }; err = '';
      if (j === 0 && h === current.handle) syncGallery(qv.colour);
      qvReturn = null; closeQV(); render(); root.querySelector(`[data-qv="${j}"]`)?.focus();
    }
  });
  document.addEventListener('keydown', e => {
    if (!qv) return;
    if (e.key === 'Escape') { e.stopImmediatePropagation(); return closeQV(); }
    if (e.key === 'Tab') { // keep focus inside the drawer while it is open
      const f = [...qvEl.querySelectorAll('button:not([disabled]), a[href]')].filter(x => x.offsetParent);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f.at(-1).focus(); }
      else if (!e.shiftKey && document.activeElement === f.at(-1)) { e.preventDefault(); f[0].focus(); }
    }
  }, true);

  // ---------- add to bag: every pack in one request, then the theme's own mini cart ----------
  function addToBag() {
    if (busy || soldOutRows().length) return;
    const qty = new Map();
    rows.forEach(r => { const v = rowVariant(r); qty.set(v.id, (qty.get(v.id) || 0) + 1); });
    const bundle = 'mp-' + Date.now().toString(36);
    const items = [...qty].map(([id, quantity]) => ({ id, quantity, properties: { _fsn_multipack: bundle } }));
    busy = true; err = ''; render();
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
      .then(r => r.json().then(d => { if (!r.ok || d.status) throw new Error(d.description || d.message || 'Could not add to bag'); }))
      .then(() => {
        if (window.PROJ && PROJ.ajaxcart && typeof PROJ.ajaxcart.updateCart === 'function') PROJ.ajaxcart.updateCart();
        else window.location.href = '/cart';
      })
      .catch(e => { console.error('[fsn-multipack] add to bag failed:', e); err = e.message || 'Sorry, something went wrong. Please try again.'; })
      .finally(() => { busy = false; render(); });
  }

  // social proof: store-wide rating + hosts line in place of the per-product "(9)" review count
  const summary = C.proof && document.querySelector('.slp-details .product-app');
  if (summary && C.proofText) {
    summary.classList.add('fsn-mp-hidden');
    const rating = parseFloat(C.proofRating);
    summary.insertAdjacentHTML('afterend', `<div class="fsn-mp-proof-wrap" style="--order-m:3"><a class="fsn-mp-proof" href="#reviews">
      <span class="fsn-mp-proof__stars" aria-hidden="true">★★★★★</span>${rating > 0 ? `<b>${rating.toFixed(1)}/5</b><span class="fsn-mp-proof__sep" aria-hidden="true">|</span>` : ''}<span>${esc(C.proofText)}</span></a></div>`);
    summary.nextElementSibling.querySelector('a').addEventListener('click', e => {
      const reviews = document.querySelector('[id$="17775866822eb98526"]') || document.querySelector('[id*="junip"], .junip-product-review');
      if (reviews) { e.preventDefault(); reviews.scrollIntoView({ behavior: 'smooth' }); }
    });
  }

  render();
  // if the page's colour is sold out, pack 1 starts on another colour: show that one in the gallery too
  if (initialColour && rows[0].colour !== initialColour) syncGallery(rows[0].colour);
  document.documentElement.classList.add('fsn-mp-ready');
  placeSticky();
})();
